<template>
  <div class="page">
    <div class="rule">
      <div class="rule-item">
        <div class="rule-item-title">
          <aside class="num">1</aside>
          参与资格
        </div>
        <div class="rule-item-content">
          <div>
            在活动期间，发布房源且房源未删除的用户将自动解锁「房东学院」，可通过「我的」-「房东学院」进入活动页面。参与活动并领取奖励的用户需满足以下条件：
          </div>
          <div class="sub-content">
            <div>1.发布至少一套房源并通过平台审核；</div>
            <div>2.房源状态为「开放中」，且未被删除或下架；</div>
            <div>3.每项任务的奖励每位用户仅可领取一次。</div>
          </div>
        </div>
      </div>
      <div class="rule-item">
        <div class="rule-item-title">
          <aside class="num">2</aside>
          奖励领取方式
        </div>
        <div class="rule-item-content">
          <div>
            完成任务并符合条件的用户，可在「房东学院」任务列表中免费领取「一键擦亮」奖励。
          </div>
        </div>
      </div>
      <div class="rule-item">
        <div class="rule-item-title">
          <aside class="num">3</aside>
          奖励查看与使用
        </div>
        <div class="rule-item-content">
          <ul >
            <li>可在「我的」 - 「我的房源」中查看已获得的「一键擦亮」次数。 </li>
            <li>在 App 内点击「一键擦亮」即可使用，为房源带来一次额外曝光机会。</li>
          </ul>
        </div>
      </div>
      <div class="rule-item">
        <div class="rule-item-title">
          <aside class="num">4</aside>
          奖励有效期
        </div>
        <div class="rule-item-content">
          <ul>
            <li>「一键擦亮」功能领取后永久有效。建议您在领取后及时使用，以获得更好的曝光效果。 </li>
          </ul>
        </div>
      </div>
      <div class="rule-item">
        <div class="rule-item-title">
          <aside class="num">5</aside>
          温馨提示
        </div>
        <div class="rule-item-content">
          <aside class="sub-title">
            1.违规处理
          </aside>
          <div class="pl12">
            <div >
              活动期间，如用户存在任何违规或不当行为（包括但不限于使用第三方软件、利用系统漏洞、作弊领取、虚假完成任务等，以 Wellcee 判定为准），或 Wellcee 有合理理由认为存在违规操作，平台有权根据情节严重程度采取包括但不限于以下措施：
            </div>
            <ul class="sub-ul-content">
              <li>限制或禁止继续参与活动；</li>
              <li>警告或限制账号功能；</li>
              <li>不予发放或收回已发放的奖励。</li>
            </ul>
          </div>
          <aside class="sub-title">
            2.参与限制
          </aside>
          <div class="pl12">
            <ul class="sub-ul-content">
              <li>每位新手房东仅可参与一次活动；</li>
              <li>活动页面将持续开放，但奖励不可重复领取；</li>
              <li>每位用户仅可使用一个账号参与，同一手机号、登录账号、IP 或其他可识别为同一用户的情况均视为同一用户；</li>
              <li>未登录用户无法参与活动。</li>
            </ul>
          </div>
          <aside class="sub-title">
            3.规则调整
          </aside>
          <div class="pl12">
            Wellcee 可能因法律法规、政策要求、活动实际情况、经营策略或合作方原因，在法律允许范围内，对活动进行<span class="weight">变更、中止或终止</span>，或对本规则进行适当调整。 如遇不可抗力或情势变更（如重大灾害、政府指令、网络攻击、系统故障等），Wellcee有权依照相关法律法规主张免责。
          </div>
          <aside class="sub-title">
            4.客服咨询
          </aside>
          <div class="pl12">
            如您对活动规则有任何疑问，可前往「我的」-「帮助与客服」进行咨询。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {useRoute} from "vue-router";

export default {
  data() {
    return {
      email: '',
      lang: '',
    };
  },
  mounted() {
    const route = useRoute();
    this.lang = ['zh', 'en', 'tw'].includes(route.query.lang) ? route.query.lang : 'zh';
    if (route.query.theme == 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
    if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
    }
    document.title = "规则说明"
  },
  methods: {},
};
</script>


<style lang="scss" scoped>
.page{
  background-color: var(--wlc-bg-white-2);
  padding: 15px;
}
.rule {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 15px;
  background-color: var(--wlc-bg-white);
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  word-wrap: break-word;
  white-space: normal;
  border-radius: 15px;
  .rule-item{
    margin-bottom: 32px;
    .pl12{
      padding-left: 12px;
    }
    .weight{
      font-weight: 600;
    }
    .rule-item-title{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color:  var(--wlc-text-color);
      line-height: 24px;
      font-weight: 600;
      margin-bottom: 4px;
      font-size: 16px;
      .num{
        display: flex;
        width: 16px;
        height: 16px;
        font-size: 10px;
        justify-content: center;
        align-items: center;
        background: #2DB6B6;
        color: #fff;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
    .rule-item-content{
      .sub-content{
        padding-left: 4px;
      }
      .sub-title{
        font-weight: 600;
      }
      ul{
        padding-left: 20px;
        li{
          list-style: disc;
        }
      }
      .sub-ul-content{
        padding-left: 20px;
      }
    }
  }
}

</style>
